export default {
  storeValueMaxWidth: '100%',
};
